import { changeRoute, resetRoute } from '../actions/publicActions';
import { DEEPLINK_DEFINITIONS } from '../routes/bootstrapDeepLinkDefinitions';
import { navigateToRoute, setForceRouteHandler } from 'owa-router';
import { initializeWindowTitle } from 'owa-shared-bootstrap';
import { orchestrator } from 'satcheljs';

const DelayAfterRenderInMilliseconds = 100;

orchestrator(changeRoute, actionMessage => {
    resetRoute();

    const deeplinkDefinition = DEEPLINK_DEFINITIONS[actionMessage.view];

    initializeWindowTitle(deeplinkDefinition.getModuleName);

    setForceRouteHandler(true);
    navigateToRoute(deeplinkDefinition.getRouteSegments());

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (22,5): Object is possibly 'undefined'.
    // @ts-expect-error
    deeplinkDefinition.postLazyAction.import();

    setTimeout(() => {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (28,9): Object is possibly 'undefined'.
        // @ts-expect-error
        deeplinkDefinition.postLazyAction.importAndExecute();
    }, DelayAfterRenderInMilliseconds);
});
